module.exports = __webpack_public_path__ + "static/media/face3.baefbc78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/face3.svg
// module id = 973
// module chunks = 0